(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initGallery(gallery) {
    if (gallery.dataset.rgSeriesReady) return;
    gallery.dataset.rgSeriesReady = 'true';
    const slides = [...gallery.querySelectorAll('[data-rg-series-slide]')];
    const dots = [...gallery.querySelectorAll('[data-rg-series-select]')];
    const previous = gallery.querySelector('[data-rg-series-step="-1"]');
    const next = gallery.querySelector('[data-rg-series-step="1"]');
    const track = gallery.querySelector('[data-rg-series-track]');
    const mobile = window.matchMedia('(max-width: 749px)');
    if (slides.length < 2) return;
    let index = 0;
    let visible = false;
    let paused = false;
    let timer;
    const select = (target, move = true, animate = true) => {
      index = Math.max(0, Math.min(slides.length - 1, target));
      slides.forEach((slide, slideIndex) => { slide.hidden = !mobile.matches && slideIndex !== index; });
      dots.forEach((dot, dotIndex) => { dot.setAttribute('aria-current', String(dotIndex === index)); });
      if (previous) previous.hidden = index === 0;
      if (next) next.hidden = index === slides.length - 1;
      if (mobile.matches && move && track) track.scrollTo({ left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: animate && !reduceMotion.matches ? 'smooth' : 'instant' });
    };
    const stop = () => { clearInterval(timer); timer = undefined; };
    const start = () => {
      stop();
      if (!visible || paused || reduceMotion.matches || document.hidden) return;
      timer = setInterval(() => select((index + 1) % slides.length), Number(gallery.dataset.interval) || 3000);
    };
    gallery.addEventListener('click', event => {
      const dot = event.target.closest('[data-rg-series-select]');
      const arrow = event.target.closest('[data-rg-series-step]');
      if (dot) select(Number(dot.dataset.rgSeriesSelect));
      if (arrow) select(index + Number(arrow.dataset.rgSeriesStep));
      if (dot || arrow) start();
    });
    gallery.addEventListener('mouseenter', () => { paused = true; stop(); });
    gallery.addEventListener('mouseleave', () => { paused = false; start(); });
    gallery.addEventListener('focusin', () => { paused = true; stop(); });
    gallery.addEventListener('focusout', () => { paused = false; start(); });
    let scrollTimer;
    track?.addEventListener('scroll', () => {
      if (!mobile.matches) return;
      stop();
      const target = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      select(target, false);
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(start, 150);
    }, { passive: true });
    gallery.addEventListener('pointerdown', event => { if (event.pointerType === 'touch') { paused = true; stop(); } });
    const resume = event => { if (event.pointerType === 'touch') { paused = false; start(); } };
    gallery.addEventListener('pointerup', resume);
    gallery.addEventListener('pointercancel', resume);
    window.addEventListener('resize', () => select(index, true, false));
    document.addEventListener('visibilitychange', start);
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      if (gallery.isConnected) start(); else { stop(); observer.disconnect(); }
    }, { threshold: .2 });
    observer.observe(gallery);
    reduceMotion.addEventListener('change', start);
    select(0, true, false);
  }

  function initLight(root) {
    if (root.dataset.rgSeriesReady) return;
    root.dataset.rgSeriesReady = 'true';
    const cards = [...root.querySelectorAll('[data-rg-series-light-card]')];
    const tabs = [...root.querySelectorAll('[data-rg-series-light-select]')];
    const viewport = root.querySelector('.rg-series-light__viewport');
    const count = root.querySelector('[data-rg-series-light-count]');
    const previous = root.querySelector('[data-rg-series-light-step="-1"]');
    const next = root.querySelector('[data-rg-series-light-step="1"]');
    if (!cards.length) return;
    let index = 0;
    let scrolling = false;
    const select = (target, move) => {
      index = Math.max(0, Math.min(cards.length - 1, target));
      cards.forEach((card, cardIndex) => card.classList.toggle('is-active', cardIndex === index));
      tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        const detail = tab.querySelector('.rg-series-light__detail');
        if (detail) detail.style.height = active ? `${detail.scrollHeight}px` : '0px';
      });
      if (count) count.textContent = `${index + 1} / ${cards.length}`;
      if (previous) previous.disabled = index === 0;
      if (next) next.hidden = index === cards.length - 1;
      if (move && viewport && window.matchMedia('(max-width: 749px)').matches) {
        scrolling = true;
        viewport.scrollTo({ left: cards[index].offsetLeft - cards[0].offsetLeft, behavior: reduceMotion.matches ? 'instant' : 'smooth' });
        setTimeout(() => { scrolling = false; }, reduceMotion.matches ? 0 : 500);
      }
    };
    root.addEventListener('click', event => {
      const tab = event.target.closest('[data-rg-series-light-select]');
      const arrow = event.target.closest('[data-rg-series-light-step]');
      if (tab) select(Number(tab.dataset.rgSeriesLightSelect), true);
      if (arrow) select(index + Number(arrow.dataset.rgSeriesLightStep), true);
    });
    viewport?.addEventListener('scroll', () => {
      if (scrolling || !window.matchMedia('(max-width: 749px)').matches) return;
      const target = cards.reduce((best, card, cardIndex) =>
        Math.abs(card.offsetLeft - cards[0].offsetLeft - viewport.scrollLeft) < best.distance
          ? { index: cardIndex, distance: Math.abs(card.offsetLeft - cards[0].offsetLeft - viewport.scrollLeft) }
          : best, { index: 0, distance: Infinity });
      select(target.index, false);
    }, { passive: true });
    window.addEventListener('resize', () => {
      const detail = tabs[index]?.querySelector('.rg-series-light__detail');
      if (detail) detail.style.height = `${detail.scrollHeight}px`;
    });
    select(0, false);
  }

  const init = root => {
    root.querySelectorAll('[data-rg-series-gallery]').forEach(initGallery);
    root.querySelectorAll('[data-rg-series-light]').forEach(initLight);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
